export default __webpack_public_path__ + "static/media/lootswap_logo2.9a888d03.png";